var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "clvr-config-element-list" },
    [
      _c(_setup.KhEditableList, {
        attrs: {
          "datatable-config": _setup.datatableConfig,
          data: _setup.listItems,
          "use-kh-editable": "",
          "use-formula-form": "",
          "formula-schema": _setup.schema,
          "show-copy": false,
          "do-submit": _setup.onSubmit,
          "do-delete": _setup.onDelete,
          "confirm-delete-message": _setup.getTranslation("delete_confirm"),
          "label-ok": "clevehr:common-Backup",
          "default-data-form": { data: null },
          "add-btn-in-header": "",
        },
        on: {
          startEdition: _setup.onStartEdition,
          startCreation: _setup.onStartCreation,
          "manager:init": _setup.initSchema,
        },
        scopedSlots: _vm._u([
          {
            key: "titleFormModal",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_setup.getTranslation("add_title")) + " "),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }